<template src="./Burger.html"></template>
<style src="./Burger.scss" lang="scss"></style>

<script>
  import TreeList from '@/components/TreeList/TreeList'

  /**
   * Burger menu in navigation.
   * @vue-data {boolean} hover If Burger menu is hovered
   * @vue-data {string | number} timer Timer id for hover state
   * @vue-data {string} id An unique identifier for the component instance
   * @vue-data {Object[]} elements An array of objects to fill menu with
   * @listens Document#click
   */
  export default {
    name: 'HpBurger',
    props: {
      elements: Array
    },
    data () {
      return {
        hover: false,
        timer: '',
        id: this._uid,
        brand: '',
        paddingTop: 0
      }
    },
    methods: {
      /**
       * To burger or not to burger: That is the question.
       * @private
       */
      toBurgerOrNotToBurger () {
        this.$el.querySelector('label').setAttribute('data-burger', 'true')
        clearInterval(this.timer)
      },
      close () {
        const checkbox = this.$el.querySelector('input[type=checkbox]:checked')

        if (checkbox) {
          checkbox.checked = false
        }
      },
      setPaddingTop () {
        const spacingFromTop = document.querySelector('[data-component="header"]').getBoundingClientRect().top
        if (this.paddingTop === spacingFromTop && spacingFromTop === 0) { return }

        document.querySelector('[data-part="scrollable-container"]').style.setProperty('padding-top', `${spacingFromTop}px`)
        this.paddingTop = spacingFromTop
      }
    },
    watch: {
      hover: function (val) {
        if (this.hover) {
          this.timer = setInterval(this.toBurgerOrNotToBurger, 25000)
        } else {
          this.$el.querySelector('label').removeAttribute('data-burger')
          clearInterval(this.timer)
        }
      }
    },
    components: {
      'hp-tree-list': TreeList
    },
    created () {
      this.brand = process.env.VUE_APP_BRAND
      // HOMEPAGE-4065: safari has a render bug when rotate the device
      // it doesn't set the fixed burger menu to the left => trigger rerendering
      window.addEventListener('orientationchange', () => {
        const layer = this.$el.querySelector('[data-layer]')
        layer && (layer.style.display = 'none')
        setTimeout(() => {
          layer && (layer.style.display = '')
        }, 0)
      })
    }
  }
</script>
